import type { Dispatch, SetStateAction } from 'react';
import { useState } from 'react';
import { Button, Inline, Stack } from '@etg/wings';
import { css, mediaQueries } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import type {
  RebookingTripBoundsType,
  RebookingTripTypeType,
} from '../../../../../change-trip/models';
import type { BoundsType } from '../../../../models';
import type { TripType } from '../model';
import TripItinerary from '../../../../../../widgets/trip-itinerary/TripItinerary';

const buttonStyles = css`
  @media ${mediaQueries.small.only} {
    margin: auto;
  }
`;

interface ItineraryDetailsProps {
  bounds: BoundsType | RebookingTripBoundsType;
  setIsItineraryDrawerSelfTransferModalOpen?: Dispatch<SetStateAction<boolean>>;
  tripType: TripType | RebookingTripTypeType;
}

export const TripDetails = ({
  bounds,
  setIsItineraryDrawerSelfTransferModalOpen,
  tripType,
}: ItineraryDetailsProps) => {
  const { t } = useTranslation();
  const [showTripDetails, setShowTripDetails] = useState(false);
  const buttonLabel = showTripDetails
    ? t('Result.TripDetails.HideTripDetails.Button.Label')
    : t('Result.TripDetails.ShowTripDetails.Button.Label');

  return (
    <Stack data-testid="trip-details-wrapper">
      <Inline>
        <Button
          className={buttonStyles}
          data-testid="trip-details-button"
          onClick={() => setShowTripDetails(!showTripDetails)}
          size="small"
        >
          {buttonLabel}
        </Button>
      </Inline>

      {showTripDetails && (
        <TripItinerary
          bounds={bounds}
          hasBoundBorder
          setIsItineraryDrawerSelfTransferModalOpen={setIsItineraryDrawerSelfTransferModalOpen}
          tripType={tripType}
        />
      )}
    </Stack>
  );
};
